import Vue from 'vue'
import axios from 'axios'
import ViewUI from 'view-design'
import App from './App'
import store from './store'
import router from './router'
import 'view-design/dist/styles/iview.css'
import './permission'
// 完整引入，main.js写入以下代码
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Print from 'vue-print-nb'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import {MessageBox,Message} from 'element-ui'
// Global instruction 
Vue.use(Print);
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.use(ViewUI)

Vue.use(Antd);
Vue.prototype.$axios = axios
Vue.prototype.$message=Message
Vue.prototype.$confirm = MessageBox.confirm
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
})